module.exports = __webpack_public_path__ + "img/D-faq-icon-b.6db703f1.svg";